export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9415.7287bf45.jpg";